class TextHighlight {
	constructor() {

		const items = document.querySelectorAll(".text-underline");
		const highlightColor = getComputedStyle(document.body).getPropertyValue('--color-orange');

		for (let i = 0; i < items.length; i++) {
			const elem = items[i];

			let start = ( elem.dataset.start ) ? elem.dataset.start : "top 90%";
			let end = ( elem.dataset.end ) ? elem.dataset.end : "top 60%";

			gsap.to( elem, {
				scrollTrigger: {
					trigger: elem,
					start: start,
					end: end,
					scrub: 1
				},
				color: highlightColor
			});
		}
	}
}
